import { useEffect, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useQueryResponse } from './core/QueryResponseProvider';

import AddMessageComponent from './AddMessageComponent';
import { ListViewProvider, useListView } from './core/ListViewProvider';
import { PartyLedgerEditModal } from './party-ledger-edit-modal/PartyLedgerEditModal';
import { PartyLedgerListHeader } from './components/header/PartyLedgersListHeader';
import { PartyLedgerTable } from './table/PartyLedgersTable';
import { QueryRequestProvider } from './core/QueryRequestProvider';
import { QueryResponseProvider } from './core/QueryResponseProvider';
import BalanceComponent from './BalanceComponent';
import { toggleChecked } from 'src/store/balanceShow/actions';
import { resetEditMode } from 'src/store/editState/actions';
interface RowData {
  id: number;
  sender_id: number;
  receiver_id: number;
  amount: number;
  remarks: string;
  date: string;
  credit?: number;
  debit?: number;
  [key: string]: any;
}

const PartyLedgerList = () => {
  const { itemIdForUpdate } = useListView();
  const { refetch } = useQueryResponse();

  const cityList = useSelector((state: any) => state.commonList.cityList);
  const isAdmin = cityList?.roleInfo?.id === 1 || cityList?.roleInfo?.id === 2;
  const isGeneralListPermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.general_report_list === true;

  const [senderId, setSenderId] = useState<any>();
  const [receiverId, setReceiverId] = useState();
  const [alterNative, setAlterNative] = useState(1);
  const [selectedRows, setSelectedRows] = useState<RowData[]>([]);
  const [prevSender, setPrevSender] = useState(null);
const [partyId, setPartyId] = useState<any>(null);
const isEditMode = useSelector((state: any) => state.editState.isEditMode);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const showBalance = useSelector((state: any) => state.toggle?.isChecked);
  const [apiTotals, setApiTotals] = useState({
    total_Credit: 0,
    total_Debit: 0,
    total_Balance: 0,
  });

  const dispatch = useDispatch()
  console.log("party id from party ledger list",partyId);


  
console.log("receiver id",receiverId);

useEffect(() => {
  if (isEditMode) {
    setSelectedRows([]);
    dispatch(resetEditMode()); // Reset the edit mode after clearing selected rows
  }
}, [isEditMode, dispatch]);
  useEffect(() => {
    if (senderId !== prevSender) {
      setSelectedRows([]); 
      setPrevSender(senderId);
      dispatch({ type: 'SET_RECEIVER_ID', payload: null });
    }
  }, [senderId]);

  return (
    <>
      <Card className='mb-4'>
        <PartyLedgerListHeader
          senderId={senderId}
          setSenderId={setSenderId}
          receiverId={receiverId}
          setReceiverId={setReceiverId}
          alterNative={alterNative}
          setAlterNative={setAlterNative}
          partyId={partyId}
          setPartyId={setPartyId}
          setApiTotals={setApiTotals}
          setIsCheckboxChecked={setIsCheckboxChecked}
          setSelectedRows={setSelectedRows}
        />
      </Card>
      {isAdmin || true || isGeneralListPermission ? (
        <Row>
          <Col md={2} className='pe-md-1'>
            <Card className='custom-add-message-sticky mb-2'>
              <AddMessageComponent
                senderId={senderId}
                setSenderId={setSenderId}
                receiverId={receiverId}
                setReceiverId={setReceiverId}
                alterNative={alterNative}
                setAlterNative={setAlterNative}
              />
            </Card>
            {(selectedRows.length > 0 || isCheckboxChecked) && <BalanceComponent senderId={senderId} selectedRows={selectedRows} prevSender={prevSender} 
              setPrevSender={setPrevSender} isCheckboxChecked={isCheckboxChecked} apiTotals={apiTotals} />}
          </Col>
          <Col md={10} className='ps-md-2'>
            <Card className='p-2'>
              <PartyLedgerTable 
                selectedRows={selectedRows} 
                setSelectedRows={setSelectedRows} 
                partyId={partyId} 
                receiverId={receiverId}
                setPartyId={setPartyId} 
                setReceiverId={setReceiverId}
                senderId={senderId}
                prevSender={prevSender}
                setPrevSender={setPrevSender}
                isCheckboxChecked={isCheckboxChecked}
                setIsCheckboxChecked={setIsCheckboxChecked}
              />
            </Card>
          </Col>
        </Row>
      ) : (
        ''
      )}
      {itemIdForUpdate !== undefined && <PartyLedgerEditModal />}
    </>
  );
};

const PartyLedgerListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PartyLedgerList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
);

export { PartyLedgerListWrapper };